/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleRelationalTagModel } from '../../models/article-relational-tag-model';

export interface ArticlePublisherIdIdRelationalTagLanguageIdPost$Params {
  publisherId: string;
  id: string;
  languageId: string;
      body?: ArticleRelationalTagModel
}

export function articlePublisherIdIdRelationalTagLanguageIdPost(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdRelationalTagLanguageIdPost$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdRelationalTagLanguageIdPost.PATH, 'post');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
    rb.path('languageId', params.languageId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as MediaStrictHttpResponse<void>;
    })
  );
}

articlePublisherIdIdRelationalTagLanguageIdPost.PATH = '/Article/{publisherId}/{id}/RelationalTag/{languageId}';
